module.exports = __webpack_public_path__ + "img/trash.04a727cf.svg";